import { createStore } from 'effector'
import { getTotalAccountValueFx } from './effects'

export const $totalAccountValue = createStore<number | null>(0).on(getTotalAccountValueFx.doneData, (_, data) => {
  return data.total_value ?? 0
})
